<template>
  <div class="content-body">
    <div class="top">新建广告</div>
    <div class="rate">
      <ul><li><div class="wrap_title_block">1.广告组</div><div class="block_left"></div></li><li><div class="block_right"></div><div class="wrap_title_block">2.广告定向</div><div class="block_left"></div></li><li><div class="block_right"></div><div class="wrap_title_block">3.广告预算和出价</div><div class="block_left"></div></li><li><div class="block_right"></div><div class="wrap_title_block">4.广告创意</div><div class="block_left"></div></li></ul>
    </div>
    <div class="group">
      <div class="title">广告组</div>
      <div class="type">
        <el-radio-group v-model="groupType" size="small">
          <el-radio-button label="1" v-if="isShowType">选择广告组</el-radio-button>
          <el-radio-button label="0" v-if="isShowAddType">新建广告组</el-radio-button>
        </el-radio-group>
      </div>
      <div class="form">
        <el-form label-width="160px" size="small" label-position="right" v-if="groupType === '1' && isShowType">
          <el-form-item label="广告组名:" required>
            <el-select v-model="plan.plan_id" placeholder="选择已有广告组" style="width: 160px;" @change="changePlan">
              <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日预算:" required>
            <el-input :value="plan.budget" disabled style="width: 160px; margin-right: 10px;" size="small"></el-input>元
          </el-form-item>
          <el-form-item label="平台:" required>
            <el-input value="移动版" disabled style="width: 160px;" size="small"></el-input>
          </el-form-item>
        </el-form>
        <el-form label-width="160px" size="small" label-position="right" v-else>
          <el-form-item label="广告组名:" required>
            <el-input v-model="plan.title" style="width: 160px;" size="small"></el-input>
          </el-form-item>
          <el-form-item label="日预算:" required>
            <el-radio v-model="plan.budget_type" label="0">不限</el-radio>
            <el-radio v-model="plan.budget_type" label="1">自定义</el-radio>
            <span v-show="plan.budget_type === '1'"><el-input v-model="plan.budget" placeholder="输入金额不低于1000元" style="width: 180px;" size="small"></el-input>元</span>
          </el-form-item>
          <el-form-item label="平台:" required>
            <el-radio v-model="radio" label="1">移动版</el-radio>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="line"></div>
    <div class="group">
      <div class="title">广告计划</div>
      <el-form label-width="160px" size="small" ref="form" :model="form" :rules="rules" label-position="right">
        <div class="name">广告名称</div>
        <el-form-item label="计划名称:" prop="adv_name">
          <el-input v-model="form.adv_name" style="width: 240px;" size="small" maxlength="20" placeholder="最多输入20个字符"></el-input>
        </el-form-item>
        <div class="name">广告定向</div>
        <el-form-item label="平台:" required>
          <el-radio v-model="radio" label="1">移动版</el-radio>
        </el-form-item>
        <el-form-item label="系统:" required>
          <el-checkbox-group v-model="form.phone_system">
            <el-checkbox label="1">Android</el-checkbox>
            <el-checkbox label="2">IOS</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="性别:" required>
          <el-radio-group v-model="other.sex">
            <el-radio label="0">不限</el-radio>
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="投放区域" required>
          <el-radio-group v-model="other.city">
            <el-radio label="1">不限</el-radio>
            <el-radio label="2">自定义</el-radio>
          </el-radio-group>
					<!-- <el-cascader v-if="other.city === '2'" :options="region" v-model="other.city_value" :props="propsCity" clearable clearable collapse-tags style="width: 350px; margin-left: 20px;"></el-cascader> -->
          <el-cascader v-if="other.city === '2'" :options="options" :props="city_props" v-model="other.city_value" clearable collapse-tags style="width: 350px; margin-left: 20px;"></el-cascader>
        </el-form-item>
        <el-form-item label="年龄" required>
          <el-checkbox @change="changeAge" v-model="other.ageTop">不限</el-checkbox>
          <el-checkbox-group v-model="other.age" @change="changeAgeGroup" style="display: inline-block; margin-left: 30px;">
            <el-checkbox label="1">0-17</el-checkbox>
            <el-checkbox label="2">18-24</el-checkbox>
            <el-checkbox label="3">25-34</el-checkbox>
            <el-checkbox label="4">35-44</el-checkbox>
            <el-checkbox label="5">45-54</el-checkbox>
            <el-checkbox label="6">55+</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="消费能力" required>
          <el-checkbox @change="changePay" v-model="other.payTop">不限</el-checkbox>
          <el-checkbox-group v-model="other.pay" @change="changePayGroup" style="display: inline-block; margin-left: 30px;">
            <el-checkbox label="1">低</el-checkbox>
            <el-checkbox label="2">中</el-checkbox>
            <el-checkbox label="3">高</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="网络环境" required>
          <el-checkbox @change="changeNetwork" v-model="other.networkTop">不限</el-checkbox>
          <el-checkbox-group v-model="other.network" @change="changeNetworkGroup" style="display: inline-block; margin-left: 30px;">
            <el-checkbox label="1">2G</el-checkbox>
            <el-checkbox label="2">3G</el-checkbox>
            <el-checkbox label="3">4G</el-checkbox>
            <el-checkbox label="4">5G</el-checkbox>
            <el-checkbox label="5">WIFI</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="网络运营商" required>
          <el-checkbox @change="changeService" v-model="other.serviceTop">不限</el-checkbox>
          <el-checkbox-group v-model="other.service" @change="changeServiceGroup" style="display: inline-block; margin-left: 30px;">
            <el-checkbox label="1">中国联通</el-checkbox>
            <el-checkbox label="2">中国电信</el-checkbox>
            <el-checkbox label="3">中国移动</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="手机品牌" required>
          <el-radio-group v-model="other.phone">
            <el-radio label="1">不限</el-radio>
            <el-radio label="2">自定义</el-radio>
          </el-radio-group>
          <el-cascader v-if="other.phone === '2'" :options="phone" :props="props" v-model="other.phone_value" clearable collapse-tags style="width: 350px; margin-left: 20px;"></el-cascader>
        </el-form-item>
        <el-form-item label="安装应用偏好" required>
          <el-radio-group v-model="other.like">
            <el-radio label="1">不限</el-radio>
            <el-radio label="2">自定义</el-radio>
          </el-radio-group>
          <el-cascader v-if="other.like === '2'" :options="travel_data" :props="other_props" v-model="other.like_value" clearable collapse-tags style="width: 350px; margin-left: 20px;"></el-cascader>
        </el-form-item>
        <el-form-item label="已安装APP定向" required>
          <el-radio-group v-model="other.app">
            <el-radio label="1">不限</el-radio>
            <el-radio label="2">自定义</el-radio>
            <el-radio label="3">按APP</el-radio>
          </el-radio-group>
          <el-tooltip placement="top-start" content="受IOS系统限制，投放IOS流量请不要勾选此定向。">
            <div class="tips">?</div>
          </el-tooltip>
          <el-transfer v-model="other.app_value" :data="app_directional" v-if="other.app === '2'"></el-transfer>
          <el-transfer v-model="other.app_value2" :data="app_exclude" v-show="other.app === '3'"></el-transfer>
        </el-form-item>
        <el-form-item label="已安装APP排除" required>
          <el-radio-group v-model="other.app2">
            <el-radio label="1">不限</el-radio>
            <el-radio label="2">自定义</el-radio>
            <el-radio label="3">按APP</el-radio>
          </el-radio-group>
          <el-tooltip placement="top-start" content="受IOS系统限制，投放IOS流量请不要勾选此定向。">
            <div class="tips">?</div>
          </el-tooltip>
          <el-transfer v-model="other.app2_value" :data="app_directional2" v-if="other.app2 === '2'"></el-transfer>
          <el-transfer v-model="other.app2_value2" :data="app_exclude2" v-show="other.app2 === '3'"></el-transfer>
        </el-form-item>
        <el-form-item label="广告点击偏好" required>
          <el-radio-group v-model="other.click">
            <el-radio label="1">不限</el-radio>
            <el-radio label="2">自定义</el-radio>
          </el-radio-group>
          <el-cascader v-if="other.click === '2'" :options="click_data" :props="other_props" v-model="other.click_value" clearable collapse-tags style="width: 350px; margin-left: 20px;"></el-cascader>
        </el-form-item>
        <el-form-item label="兴趣定向" required>
          <el-radio-group v-model="other.inter">
            <el-radio label="1">不限</el-radio>
            <el-radio label="2">用户阅读兴趣</el-radio>
          </el-radio-group>
          <el-transfer v-model="other.inter_value" :data="inter_orientation" v-if="other.inter === '2'"></el-transfer>
        </el-form-item>
        <div class="name">广告预算和出价</div>
        <el-form-item label="广告预算:" prop="adv_budget">
          <el-select v-model="form.adv_type" style="width: 160px;">
            <el-option label="日预算" value="1"></el-option>
            <el-option label="总预算" value="2"></el-option>
          </el-select>
          <el-input v-model="form.adv_budget" style="width: 160px; margin-left: 20px; margin-right: 10px;" size="small" placeholder=""></el-input>元
        </el-form-item>
        <div style="margin: 20px 0 20px 160px;">
          <el-radio v-model="form.budget_t" label="0">立即长期投放</el-radio>
          <el-radio v-model="form.budget_t" label="1">自定义</el-radio>
          <el-date-picker v-model="form.budget_time" type="daterange" value-format="yyyy-MM-dd" align="right" v-show="form.budget_t === '1'" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </div>
        <el-form-item label="付费方式:" required>
          <el-radio v-model="form.pay_type" label="1">CPM</el-radio>
          <el-radio v-model="form.pay_type" label="2">CPC</el-radio>
        </el-form-item>
        <el-form-item label="出价:" prop="price">
          <el-input v-model="form.price" placeholder="上限5000" style="width: 180px; margin-right: 10px;" size="small"></el-input>元<span style="color: #999; font-size: 14px; margin-left: 31px;" v-text="form.pay_type === '1' ? '每千次展现出价' : '每次点击出价'"></span>
        </el-form-item>
        <el-form-item label="展现频次:">
          <el-input v-model="other.read_num_c" placeholder="每个用户看到的时间间隔（分钟）" style="width: 220px;" size="small"></el-input>
        </el-form-item>
        <el-form-item label="展现次数:">
          <el-input v-model="other.read_num" placeholder="每个用户看到的最多次数" style="width: 220px;" size="small"></el-input>
        </el-form-item>
        <el-form-item label="点击次数:">
          <el-input v-model="other.look_num" placeholder="每个用户看到的最多次数" style="width: 220px;" size="small"></el-input>
        </el-form-item>
        <div class="name">
          广告创意
          <div class="pic-show-layer">
            <div class="zero" v-if="form.upload_type === ''">
              <img src="../../assets/images/icon_style.png" alt="null">
              <div>生成的创意预览图将显示在这里</div>
            </div>
            <div class="one" v-if="form.upload_type === '1'">
              <div class="one-title">我们为您提供优质丰富的私有流量及丰富的广告样式！</div>
              <div class="img">
                <img src="../../assets/images/icon-style-show.png" alt="show-logo">
              </div>
              <div class="bottom">
                <div class="left">广告</div>
                <div class="right" v-text="form.source"></div>
              </div>
            </div>
            <div class="two" v-if="form.upload_type === '2'">
              <div class="two-img">
                <img src="../../assets/images/icon-style-show.png" alt="show-logo">
              </div>
              <div class="right-content">
                <div class="two-title">我们为您提供优质丰富的私有流量及丰富的广告样式！</div>
                <div class="bottom">
                  <div class="left">广告</div>
                  <div class="right" v-text="form.source"></div>
                </div>
              </div>
            </div>
            <div class="three" v-if="form.upload_type === '3'">
              <div class="three-title">我们为您提供优质丰富的私有流量及丰富的广告样式！</div>
              <div class="center">
                <img src="../../assets/images/icon-style-show.png" alt="show-logo">
                <img src="../../assets/images/icon-style-show.png" alt="show-logo">
                <img src="../../assets/images/icon-style-show.png" alt="show-logo">
              </div>
              <div class="bottom">
                <div class="left">广告</div>
                <div class="right" v-text="form.source"></div>
              </div>
            </div>
            <div class="four" v-if="form.upload_type === '4' || form.upload_type === '5'">
              <img src="../../assets/images/show.png" alt="show-logo">
            </div>
            <div class="three" v-if="form.upload_type === '6'">
              <div class="three-title">我们为您提供优质丰富的私有流量及丰富的广告样式！</div>
              <div class="center">
                <img src="../../assets/images/datu1.jpg" alt="show-logo" style="width: 100%; height: 80px;">
              </div>
              <div class="bottom">
                <div class="left">广告</div>
                <div class="right" v-text="form.source"></div>
              </div>
            </div>
            <div class="three" v-if="form.upload_type === '7'">
              <div class="three-title">我们为您提供优质丰富的私有流量及丰富的广告样式！</div>
              <div class="center">
                <img src="../../assets/images/chuchuang.jpg" alt="show-logo" style="width: 100%; height: 250px;">
              </div>
              <div class="bottom">
                <div class="left">广告</div>
                <div class="right" v-text="form.source"></div>
              </div>
            </div>
          </div>
        </div>
        <el-form-item label="选择样式:" required>
          <el-select v-model="form.upload_type" style="width: 220px;">
            <el-option label="请选择样式" value=""></el-option>
            <el-option label="大图" value="1"></el-option>
            <el-option label="单图" value="2"></el-option>
            <el-option label="三图" value="3"></el-option>
            <el-option label="开屏" value="4"></el-option>
            <el-option label="新视频" value="5"></el-option>
            <el-option label="新大图1" value="6"></el-option>
            <el-option label="橱窗大图" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放位置:" prop="position">
          <el-select v-model="form.position" style="width: 220px;">
            <el-option label="信息流" value="1"></el-option>
            <el-option label="详情页" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创意标题:" required v-if="form.upload_type !== '4' && form.upload_type !== '7' && form.upload_type !== ''">
          <el-input v-model="other.title" placeholder="请输入1-30个字之间" style="width: 220px;" maxlength="30" size="small"></el-input>
          <el-tooltip placement="top-start" content="介绍您的应用特色，抓住用户眼球。">
            <div class="tips">?</div>
          </el-tooltip>
          <el-popover v-model="showPopover" placement="bottom" width="60" style="margin-left: 20px;" trigger="click">
            <div class="font-line">
              <p @click="setTitle('城市')">城市</p>
              <p @click="setTitle('日期')">日期</p>
              <p @click="setTitle('星期')">星期</p>
              <p @click="setTitle('手机品牌')">手机品牌</p>
            </div>
            <el-button slot="reference" type="primary">插入词包</el-button>
          </el-popover>
          <el-tooltip placement="top-start" content="根据用户特点动态替换标题片段。">
            <div class="tips">?</div>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="副标题" required v-if="form.upload_type !== '4' && form.upload_type !== '7' && form.upload_type !== ''">
          <el-input v-model="other.name" placeholder="请输入1-30个字之间" style="width: 220px;" maxlength="30" size="small"></el-input>
          <el-tooltip placement="top-start" content="介绍您的应用特色，抓住用户眼球。">
            <div class="tips">?</div>
          </el-tooltip>
          <el-popover v-model="showPopover1" placement="bottom" width="60" style="margin-left: 20px;" trigger="click">
            <div class="font-line">
              <p @click="setName('城市')">城市</p>
              <p @click="setName('日期')">日期</p>
              <p @click="setName('星期')">星期</p>
              <p @click="setName('手机品牌')">手机品牌</p>
            </div>
            <el-button slot="reference" type="primary">插入词包</el-button>
          </el-popover>
          <el-tooltip placement="top-start" content="根据用户特点动态替换标题片段。">
            <div class="tips">?</div>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="推广目标:" required>
          <el-radio v-model="form.target" label="1">网页</el-radio>
          <el-radio v-model="form.target" label="2">应用下载</el-radio>
          <el-radio v-model="form.target" label="3">唤醒应用</el-radio>
        </el-form-item>
        <el-form-item label="下载链接" v-if="form.target === '2'">
          <el-input v-model="other.down_link" placeholder="http://" style="width: 220px;" size="small"></el-input>
        </el-form-item>
        <el-form-item label="应用包名" v-if="form.target === '2'">
          <el-input v-model="other.package" placeholder="例：com.tencent.mobileqq" style="width: 220px;" size="small"></el-input>
        </el-form-item>
        <el-form-item label="AppStoreID" v-if="form.target === '2'">
          <el-input v-model="other.app_id" placeholder="" style="width: 220px;" size="small"></el-input>
        </el-form-item>

        <el-form-item label="唤醒链接(Android)" v-if="form.target === '3'">
          <el-input v-model="other.wake_up_a" placeholder="协议://" style="width: 220px;" size="small"></el-input>
        </el-form-item>
        <el-form-item label="唤醒链接(IOS)" v-if="form.target === '3'">
          <el-input v-model="other.wake_up_i" placeholder="协议://" style="width: 220px;" size="small"></el-input>
        </el-form-item>

        <el-form-item label="推广链接" prop="url">
          <el-input v-model="form.url" placeholder="http://" style="width: 220px;" size="small"></el-input>
          <el-tooltip placement="top-start" content="用户点击广告中“立即下载”按钮以外的区域时所到达的页面。">
            <div class="tips">?</div>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="来源" prop="source">
          <el-input v-model="form.source" placeholder="请输入2-5个字" minlength="2" maxlength="5" style="width: 220px;" size="small"></el-input>
          <el-tooltip placement="top-start" content="即广告来源，展示在广告素材中，来源需与公司名称或简称保持一致。">
            <div class="tips">?</div>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="上传视频" required v-show="form.upload_type === '5'">
          <el-upload class="avatar-uploader"
            :action="getLink()"
            v-bind:on-progress="uploadVideoProcess"
            v-bind:on-success="handleVideoSuccess"
            v-bind:before-upload="beforeUploadVideo"
            v-bind:show-file-list="false">
              <div><el-button size="small">浏览...</el-button></div>
              <video v-show="form.video_path !='' && !videoFlag"
                     v-bind:src="form.video_path"
                     class="avatar video-avatar"
                     controls="controls"
                     style="margin-top: 10px;">
                  您的浏览器不支持视频播放
              </video>
              <!-- <i v-else-if="form.video_path =='' && !videoFlag"
                 class="el-icon-plus avatar-uploader-icon"></i> -->
              <el-progress v-if="videoFlag == true"
                           type="circle"
                           v-bind:percentage="videoUploadPercent"
                           style="margin-top:7px;"></el-progress>
          </el-upload>
          <div style="color: red;">上传视频不能超过100M,格式：mp4,(512≤码率≤2048)kbps</div>
        </el-form-item>
        <el-form-item label="上传素材" required>
          <el-upload action="" ref="upload" class="avatar-uploader" :show-file-list="false" :on-change="logoUpload" v-if="form.upload_type !== '3'">
            <el-button size="small">浏览...</el-button>
            <img v-if="form.pic" :src="getImage(form.pic)" class="avatar" style="margin-top: 10px;">
            <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
            <el-tooltip placement="top-start" content="视频素材播放完成后展示的图片。" v-show="form.upload_type === '5'">
              <div class="tips">?</div>
            </el-tooltip>
          </el-upload>
          <el-upload action="123" v-if="form.upload_type === '3'" list-type="picture-card" :file-list="form.pics" :on-change="onchange" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :limit="3">
            浏览...
          </el-upload>
          <div style="color: red;" v-text="font[form.upload_type]"></div>
        </el-form-item>
        <el-form-item label="上传图标" required v-show="form.upload_type === '5'">
          <el-upload action="" ref="upload" class="avatar-uploader" style="text-align: left !important;" :show-file-list="false" :on-change="logoIcon" v-if="form.upload_type !== '3'">
            <el-button size="small">浏览...</el-button>
            <img v-if="form.icon" :src="getImage(form.icon)" class="avatar" style="margin-top: 10px;">
            <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
            <el-tooltip placement="top-start" content="该图标用于广告展示，请使用清晰、健康、代表品牌形象的图片。" v-show="form.upload_type === '5'">
              <div class="tips">?</div>
            </el-tooltip>
          </el-upload>
          <div style="color: red;">宽:高1:1, 格式:jpg,png,最大:1M,数量1</div>
        </el-form-item>
        <el-form-item label="广告分类" required>
          <el-cascader :options="class_data" :props="other_props" v-model="other.adv_other" clearable collapse-tags style="width: 350px;"></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save('form')" size="small">保存</el-button>
          <el-button @click="cancel" size="small">取消</el-button>
        </el-form-item>
      </el-form>
      <div style="height: 200px;"></div>

    </div>
  </div>
</template>

<script>
import options from '../../utils/city_code.js';
import phone from '../../utils/phone_value.js';
import other_data_form from '../../utils/other_data.js';
import app_data_form from '../../utils/data_app.js';
import app_type_form from '../../utils/data_type.js';
export default {
  data() {
    const app_directional = _ => {
      const data = [];
      for (let i = 1; i <= app_type_form.length; i++) {
        if (app_type_form[i] !== undefined && app_type_form[i].name !== undefined) {
          data.push({
            key: i,
            label: app_type_form[i].name
          });
        }
      }
      return data;
    };
    const app_exclude = _ => {
      const data2 = [];
      for (let i = 1; i <= app_data_form.length; i++) {
        if (app_data_form[i] !== undefined && app_data_form[i].name !== undefined) {
          data2.push({
            key: i,
            label: app_data_form[i].name
          });
        }
      }
      return data2;
    };
    const inter_orientation = _ => {
      const data3 = [];
      for (let i = 1; i <= other_data_form.interest_orientation.length; i++) {
        data3.push({
          key: i,
          label: other_data_form.interest_orientation[i]
        });
      }
      return data3;
    };
    return {
      showPopover: false,
      showPopover1: false,
      groupType: '1',
      radio: '1',
      props: { multiple: true, children: 'city', value: 'code', label: 'name' },
      city_props: { multiple: true, children: 'children', value: 'class_id', label: 'class_name' },
      other_props: { multiple: true, children: 'children', value: 'id', label: 'name' },
      options: options,
      phone: phone,
      editFiles: [],
      videoFlag: false,
      videoUploadPercent: '',
      isShowUploadVideo: false,
      planLists: [],
      isShowType: false,
      isShowAddType: true,
      font: [
        '',
        '宽:500px, 高:250px, 格式:jpg,png,最大:1M, 数量:1',
        '宽:320px, 高:240px, 格式:jpg,png,最大:1M, 数量:1',
        '宽:320px, 高:240px, 格式:jpg,png,最大:1M, 数量:3',
        '宽:640px, 高:920px, 格式:jpg,png,最大:1M, 数量:1',
        '宽:高500:250, 格式:jpg,png,最大:1M,数量1',
        '宽:800px, 高:215px, 格式:jpg,png,gif,最大:2M, 数量:1',
        '宽:300px, 高:250px, 格式:jpg,png,gif,最大:2M, 数量:1'
      ],
      app_directional: app_directional(),
      app_directional2: app_directional(),
      app_exclude: [{ 'key': 0, 'label': '加载中...', 'disabled': true }],
      app_exclude2: [{ 'key': 0, 'label': '加载中...', 'disabled': true }],
      inter_orientation: inter_orientation(),
      other: {
        sex: '0',
        city: '1',
        city_value: [],
        ageTop: true,
        age: [],
        payTop: true,
        pay: [],
        networkTop: true,
        network: [],
        serviceTop: true,
        service: [],
        phone: '1',
        phone_value: [],
        read_num_c: '',
        read_num: '',
        look_num: '',
        title: '',
        name: '',
        down_link: '',
        package: '',
        app_id: '',
        wake_up_a: '',
        wake_up_i: '',
        adv_other: [],
        like: '1',
        like_value: [],
        app: '1',
        app_value: [],
        app_value2: [],
        app2: '1',
        app2_value: [],
        app2_value2: [],
        click: '1',
        click_value: [],
        inter: '1',
        inter_value: []
      },
      travel_data: [],
      class_data: [],
      click_data: [],
      plan: {
        title: '',
        plan_id: '',
        budget_type: '0',
        budget: ''
      },
      form: {
        adv_id: '',
        adv_name: '',
        phone_system: ['1', '2'],
        adv_type: '1',
        adv_budget: '',
        budget_t: '0',
        budget_time: [],
        pay_type: '1',
        price: '',
        upload_type: '',
        position: '',
        target: '1',
        url: 'http://',
        source: '',
        pic: '',
        pics: [],
        video_path: '',
        suffix: '',
        suffix_i: '',
        icon: ''
      },
      rules: {
        adv_name: [
          { required: true, message: '请输入计划名称', trigger: 'blur' }
        ],
        position: [
          { required: true, message: '请选择投放位置', trigger: 'change' }
        ],
        adv_budget: [
          { required: true, message: '请输入广告预算金额', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入出价', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入推广链接', trigger: 'blur' }
        ],
        source: [
          { required: true, message: '请输入来源', trigger: 'blur' }
        ]
      }
    };
  },
  props: {
    type: {
      default: 'add'
    },
    view: {
      default: 'plan'
    },
    editItem: {
      default: []
    }
  },
  created() {
    document.title = this.type === 'add' ? '新建广告' : '编辑广告';
    this.getPlanLists();
    // this.getUserInfo();
  },
  methods: {
    app_exclud_data() {
      const data2 = [];
      for (let i = 1; i <= app_data_form.length; i++) {
        if (app_data_form[i] !== undefined && app_data_form[i].name !== undefined) {
          data2.push({
            key: i,
            label: app_data_form[i].name
          });
        }
      }
      return data2;
    },
    changeAge() {
      if (this.other.ageTop) {
        this.other.age = [];
      } else {
        if (this.other.age.length <= 0) {
          this.other.ageTop = true;
        }
      }
    },
    changeAgeGroup() {
      this.other.ageTop = this.other.age.length <= 0;
    },
    changePay() {
      if (this.other.payTop) {
        this.other.pay = [];
      } else {
        if (this.other.pay.length <= 0) {
          this.other.payTop = true;
        }
      }
    },
    changePayGroup() {
      this.other.payTop = this.other.pay.length <= 0;
    },
    changeNetwork() {
      if (this.other.networkTop) {
        this.other.network = [];
      } else {
        if (this.other.network.length <= 0) {
          this.other.networkTop = true;
        }
      }
    },
    changeNetworkGroup() {
      this.other.networkTop = this.other.network.length <= 0;
    },
    changeService() {
      if (this.other.serviceTop) {
        this.other.service = [];
      } else {
        if (this.other.service.length <= 0) {
          this.other.serviceTop = true;
        }
      }
    },
    changeServiceGroup() {
      this.other.serviceTop = this.other.service.length <= 0;
    },
    setTitle(name) {
      this.showPopover = false;
      this.other.title += '{' + name + '}';
    },
    setName(name) {
      this.showPopover1 = false;
      this.other.name += '{' + name + '}';
    },
    getPlanLists() {
      this.$http.post('/trader/plan/getLists').then(res => {
        if (res.code === 200) {
          this.planLists = res.data;
          this.isShowType = res.data.length > 0;
          this.groupType = res.data.length > 0 ? '1' : '0';
          this.plan.plan_id = res.data.length > 0 ? res.data[0].plan_id : '';
          this.plan.budget = res.data.length > 0 ? res.data[0].budget : '';
          this.getOtherData();
          this.$function.hiddenLoading();
          if (this.type === 'edit') {
            this.editInit();
          }
        }
      });
    },
    editInit() {
      this.isShowAddType = false;
      this.changePlan(this.editItem.plan_id);
      this.other = this.editItem.get_info;
      this.form = {
        adv_id: this.editItem.adv_id,
        adv_name: this.editItem.adv_name,
        phone_system: this.editItem.phone_system ? this.editItem.phone_system : [],
        adv_type: this.editItem.adv_type + '',
        adv_budget: this.editItem.adv_budget,
        budget_t: this.editItem.budget_t + '',
        budget_time: this.editItem.budget_time ? this.editItem.budget_time : [],
        pay_type: this.editItem.pay_type + '',
        price: this.editItem.price,
        upload_type: this.editItem.upload_type + '',
        position: this.editItem.position + '',
        target: this.editItem.target + '',
        url: this.editItem.url,
        source: this.editItem.source,
        pic: this.editItem.pic,
        pics: this.editItem.pics ? this.editItem.pics : [],
        video_path: this.editItem.video_path,
        suffix: '',
        suffix_i: '',
        icon: this.editItem.icon
      };
    },
    getOtherData() {
      if (sessionStorage.getItem('other_data')) {
        const other_data = JSON.parse(sessionStorage.getItem('other_data'));
        this.travel_data = other_data.travel_tree;
        this.class_data = other_data.class_tree;
        this.click_data = other_data.click_tree;
      } else {
        this.$http.post('/index/index/getOtherData').then(res => {
          if (res.code === 200) {
            sessionStorage.setItem('other_data', JSON.stringify(res.data));
            this.travel_data = res.data.travel_tree;
            this.class_data = res.data.class_tree;
            this.click_data = res.data.click_tree;
          }
        });
      }
    },
    changePlan(plan_id) {
      const item = this.getPlanItem(plan_id);
      if (item) {
        this.plan.plan_id = item.plan_id;
        this.plan.budget = item.budget;
      }
    },
    getPlanItem(plan_id) {
      let one = [];
      if (this.planLists.length) {
        for (const item of this.planLists) {
          if (item.plan_id === plan_id) {
            one = item;
          }
        }
      }
      return one;
    },
    getLink() {
      return this.$Config.apiUrl + '/trader/plan/fileUpload';
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.video_path === '' && this.form.upload_type === '5') {
            this.$message.error('请上传视频');
            return false;
          }
          if (this.form.pic === '' && ['1', '2', '4', '5', '6', '7'].includes(this.form.upload_type)) {
            this.$message.error('请上传素材');
            return false;
          }
          if (this.form.pics.length !== 3 && this.form.upload_type === '3') {
            this.$message.error('请上传素材');
            return false;
          }
          if (this.form.icon === '' && this.form.upload_type === '5') {
            this.$message.error('请上传素材');
            return false;
          }

          if (parseFloat(this.form.price) < 0.5) {
            this.$message.error('出价不能低于0.5');
            return false;
          }

          const url = this.type === 'add' ? '/trader/plan/createPlan' : '/trader/plan/savePlan';
          this.$http.post(url, {
            groupType: this.groupType,
            other: this.other,
            plan: this.plan,
            form: this.form
          }).then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功');
              this.$emit('form_call_back', this.view);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      this.$emit('form_call_back', this.view);
    },
    logoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return;
      }
      if (file.raw.type.includes('gif')) {
        this.$message.error('图片格式不能是GIF');
        return;
      }

      this.$function.blobToDataURL(file.raw, res => {
        const imgType = file.raw.type.split('/');
        this.form.suffix = imgType[1];
        this.form.pic = res;
      });
    },
    logoIcon(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return;
      }
      if (file.raw.type.includes('gif')) {
        this.$message.error('图片格式不能是GIF');
        return;
      }

      this.$function.blobToDataURL(file.raw, res => {
        const imgType = file.raw.type.split('/');
        this.form.suffix_i = imgType[1];
        this.form.icon = res;
      });
    },
    getImage(logo) {
      return logo.includes('base64,') ? logo : this.$Config.apiUrl + logo;
    },
    handleRemove(file, fileList) {
      this.form.pics = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeAvatarUpload(file) {

    },
    // 当上传图片后，调用onchange方法，获取图片本地路径
    onchange(file) {
      var _this = this;
      var event = event || window.event;
      if (event) {
        const file = event.target.files[0];
        var reader = new FileReader();
        // 转base64
        reader.onload = function(e) {
          _this.form.pics.push({ name: file.name, url: e.target.result }); // 将图片路径加入editFiles
        };
        reader.readAsDataURL(file);
      }
    },
    // 上传前回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 100;
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) === -1) {
        this.$message.error('请上传正确的视频格式');
        return false;
      }
      if (!fileSize) {
        this.$message.error('视频大小不能超过100MB');
        return false;
      }
      this.isShowUploadVideo = false;
    },
    // 进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    // 上传成功回调
    handleVideoSuccess(res, file) {
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      // 后台上传地址
      if (res.code === 200) {
        this.form.video_path = '' + res.path;
      } else {
        this.$message.error(res.msg);
      }
    }
  },
  mounted() {

  },
  watch: {
    'other.app'() {
      this.other.app_value = [];
    },
    'other.app2'() {
      this.other.app2_value = [];
    },
    'plan.budget_type'(newVal) {
      if (newVal === '1') {
        this.plan.budget = '';
      }
    },
    'other.app'(newVal) {
      if (newVal === '3' && this.app_exclude.length <= 1) {
        setTimeout(() => {
          this.app_exclude = this.app_exclud_data();
        }, 0);
      }
    },
    'other.app2'(newVal) {
      if (newVal === '3' && this.app_exclude2.length <= 1) {
        setTimeout(() => {
          this.app_exclude2 = this.app_exclud_data();
        }, 0);
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    line-height: 54px;
    color: #333;
    padding-left: 22px;
  }
  .rate ul li {
    float: left;
    height: 44px;
    overflow: hidden;
    position: relative;
    .wrap_title_block {
      width: 220px;
      height: 44px;
      line-height: 44px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #0d98e2;
      text-align: center;
      background-color: #e2f1ff;
    }
    .block_left {
      width: 31px;
      height: 31px;
      background-color: #e2f1ff;
      transform: rotateZ(45deg) translateX(-22px);
      position: relative;
      margin-top: 22px;
      z-index: 9;
    }
    .block_right {
      width: 31px;
      height: 31px;
      background-color: #fff;
      transform: rotateZ(-45deg) translateX(22px);
      margin-top: 22px;
      position: relative;
      z-index: 3;
    }
    div {
      float: left;
    }
  }
  .rate ul li:first-child {
      z-index: 10;
  }
  .rate ul li:nth-child(2) {
      transform: translateX(-46px);
      z-index: 9;
  }
  .rate ul li:nth-child(3) {
      transform: translateX(-92px);
      z-index: 8;
  }
  .rate ul li:nth-child(4) {
      transform: translateX(-138px);
      z-index: 7;
  }
  .rate {
    width: 1370px;
    height: 44px;
    padding-top: 31px;
    margin-left: 57px;
    clear: both;
  }
  .group {
    width: calc(100% - 168px);
    margin-left: 84px;
    padding: 31px 0;
    position: relative;
    .title {
      font-size: 20px;
      color: #333;
      margin-bottom: 23px;
    }
    .form {
      padding-top: 31px;
    }
    .name {
      font-size: 14px;
      font-weight: 700;
      color: #333;
      margin-left: 30px;
      padding-bottom: 20px;
      position: relative;
    }
  }
  .line {
    width: calc(100% - 52px);
    margin-left: 26px;
    height: 2px;
    background: #f4f4f4;
  }
  .font-line {
    p {
      width: 100%;
      text-align: center;
      height: 30px;
      line-height: 30px;
      &:hover {
        background: #f4f4f4;
        cursor: pointer;
      }
    }
  }
  .pic-show-layer {
    position: absolute;
    top: 25px;
    left: 800px;
  }
  .zero {
    width: 342px;
    height: 178px;
    text-align: center;
    border: 1px solid #e1e3e4;
    font-size: 12px;
    color: #999;
    img {
      width: 89px;
      height: 73px;
      margin: 25px 0;
    }
  }
  .one {
    width: 288px;
    height: 213px;
    border: 1px solid #e1e3e4;
    padding: 16px 26px;
    .one-title {
      font-size: 14px;
      color: #333;
      margin-bottom: 5px;
    }
    .img {
      width: 100%;
      img {
        width: 100%;
        height: 146px;
      }
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
    .left {
      border: solid 1px #e3e3e3;
      width: 30px;
      height: 18px;
      border-radius: 3px;
      font-size: 12px;
      line-height: 15px;
      text-align: center;
      color: #999;
    }
    .right {
      font-size: 12px;
      color: #999;
    }
  }
  .two {
    width: 288px;
    height: 75px;
    display: flex;
    padding: 18px 26px;
    border: 1px solid #e1e3e4;
    .two-img {
      width: 100px;
      height: 75px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right-content {
      width: 178px;
      padding-left: 10px;
      .two-title {
        font-size: 14px;
        color: #333;
        height: 40px;
        margin-bottom: 15px;
      }
    }
  }
  .three {
    width: 288px;
    padding: 18px 26px;
    border: 1px solid #e1e3e4;
    .three-title {
      font-size: 14px;
      color: #333;
      height: 40px;
      margin-bottom: 10px;
    }
    .center {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      img {
        width: 94px;
        height: 64px;
      }
    }
  }
  .four {
    width: 288px;
    padding: 20px 26px;
    border: 1px solid #e1e3e4;
    overflow: hidden;
    img {
      height: 486px;
      width: 288px;
    }
  }

  .tips {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #ccc;
    line-height: 20px;
    text-align: center;
    color: #ccc;
    display: inline-block;
    margin-left: 20px;
  }
  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
    text-align: left !important;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    // height: 178px;
    // line-height: 178px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar {
    width: 178px;
    // height: 178px;
    display: block;
  }
</style>
